// extracted by mini-css-extract-plugin
export default {"containerSuspended":"AccountSuspendedError_containerSuspended__bolSp","margin":"AccountSuspendedError_margin__RyRWh"};